export default {
  fileCategories: [],
  listFiles: []
}
